module.exports = __webpack_public_path__ + "img/brk-logo.08caf711.png";